import 'semantic-ui-css/components/popup.css';
import 'semantic-ui-css/components/transition.css';
import './index.scss';
import React, { PropTypes } from 'react';
import { Popup as SemanticUIPopup } from 'semantic-ui-react';

const Popup = React.createClass({
    propTypes: {
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]).isRequired,
        content: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]).isRequired,
    },
    render: function() {
        const { children, content, ...other } = this.props;
        return  <SemanticUIPopup trigger={children} content={content} {...other} />;
    }
});

export default Popup;


// WEBPACK FOOTER //
// ./src/components/common/Popup/index.jsx